<template>
  <button
    ref="button"
    :class="{ selected: isSelected }"
    :disabled="disabled"
    @click="$emit('onClick')"
  >
    <TooltipStandardV2
      :text="title"
      :arrowPosition="'center-right'"
      :verticalOffset="2"
      :horizontalOffset="3"
      :style="{ flexGrow: 0, padding: '11.5px' }"
      :disabledTooltip="isSelected"
    >
      <slot name="icon"> </slot>
    </TooltipStandardV2>
  </button>
</template>

<script lang="ts" setup>
import TooltipStandardV2 from '@/design-system/atoms/TooltipStandardV2.vue'
defineProps({
  isSelected: { type: Boolean, required: false, default: false },
  disabled: { type: Boolean, required: false, default: false },
  title: { type: String, required: true }
})
defineEmits<{
  (e: 'onClick'): void
}>()
</script>
<style lang="scss" scoped>
@use '@/design-system/design-tokens/variables.scss';
@use '@/design-system/design-tokens/font-mixins';
button {
  @include font-mixins.desktop-bold-label;
  border: none;
  background-color: variables.$color-pure-white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  color: #1a1a1a;
  border-bottom: 1px solid variables.$color-lines;
  outline-style: hidden;
  outline-width: 2px;
  outline-color: variables.$color-primary-light;
  &:first-child {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  &:last-child {
    // border-bottom: 1px solid variables.$color-pure-white;
    border-bottom: none;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  &:hover:not([disabled]) {
    background-color: variables.$color-pure-white;
    color: variables.$color-primary;
  }

  &:active:not([disabled]) {
    background-color: variables.$color-primary;
    color: variables.$color-pure-white;
  }

  &.selected:not([disabled]) {
    background-color: variables.$color-primary;
    color: variables.$color-pure-white;
  }

  &[disabled] {
    background-color: variables.$color-disabled;
    color: variables.$color-text-primary;
    outline: none;
  }
}
</style>
